import React, { useEffect, useState } from "react";
import { formatRelativeTime } from "../utils/date";

export default function CommentTimestamp({ date }: { date: string }) {
    const [now, setNow] = useState(Date.now);

    useEffect(() => {
        const interval = window.setInterval(() => setNow(Date.now()), 60_000);
        return () => window.clearInterval(interval);
    }, []);

    const timestamp = new Date(date);
    const isValid = Number.isFinite(timestamp.getTime());

    return (
        <time
            dateTime={isValid ? timestamp.toISOString() : undefined}
            title={
                isValid
                    ? timestamp.toLocaleString(undefined, {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                          second: "2-digit",
                          timeZoneName: "short",
                      })
                    : "Creation time unavailable"
            }
        >
            {formatRelativeTime(timestamp, now)}
        </time>
    );
}
